import { ADD_ERROR_LOG } from "@/store/mutation_types";

const errorLog = {
  state: {
    logs: []
  },
  mutations: {
    [ADD_ERROR_LOG]: (state, log) => {
      state.logs.push(log);
    }
  },
  actions: {
    async addErrorLog({ commit }, log) {
      commit("ADD_ERROR_LOG", log);
    }
  }
};

export default errorLog;
